module.exports = __webpack_public_path__ + "static/img/bg36.3b23a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg36.png
// module id = XMXe
// module chunks = 28